import React from 'react';
import { useLogger } from '@shared-ui/logger-context';
import Layout from 'src/components/common/theme/Layout';
import { Theme } from 'src/components/common/theme/Theme';
import { GlobalFooterComponent } from 'src/components/common/modules/global-footer/code-split/footer-component';
import GlobalHeader from 'src/components/common/modules/global-header/global-header';
//import V3Navigation from 'src/components/common/modules/v3/meso/v3-navigation';
// import V3Navigation from 'src/components/common/modules/v3/brand/v3-navigation';
import V3Navigation from 'src/components/common/modules/v3/shared/v3-navigation';
import { useStores } from 'src/components/common/utils/useStore';

import { SubHeaderProps } from 'src/components/common/modules/global-header/global-header.d';
import { checkValue } from '../helper';
import { ThemeColorMode, ThemeType } from '../module-util';
import { config } from 'src/config/config';
import { ComponentLayoutType } from '../modules/component-layout/component-layout';
import V3AdUnits from '../modules/v3/brand/v3-ad-units';
import { NavigationL1Fragment } from 'src/common/__generated__/sanity/types';

interface GlobalNavigationProps {
  title: string;
  navL1: NavigationL1Fragment[];
}
export interface V3NavProps {
  id: string;
  data: SubHeaderProps;
  moduleName: string;
  themeType: string;
  themeColorMode: string;
  globalNavigationData: GlobalNavigationProps;
}
interface MasterPageProps {
  className: string;
  children: React.ReactNode;
  isSubHeader?: boolean;
  isSocialLinks?: boolean;
  subHeaderProps?: SubHeaderProps;
  socialModule?: any;
  isPartnerHeader?: boolean;
  progressBarType?: 'v1' | 'v2';
}

const MasterPage: React.FC<MasterPageProps> = (props) => {
  const {
    className,
    children,
    isSubHeader = true,
    subHeaderProps,
    isSocialLinks = false,
    socialModule,
    isPartnerHeader = false,
    progressBarType = 'v1',
  } = props;
  const { info } = useLogger();
  const {
    context: {
      site: { brand },
    },
    cpcmslitefeed: { pageModuleVersion, cpCmsLitePageData, spotlightPageData },
    sanityStore: { sanityPageData },
  } = useStores();

  const defaultTheme = config.defaultThemeType; //'Meso-Light';

  const pageData = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData
    : checkValue(spotlightPageData)
    ? spotlightPageData
    : checkValue(sanityPageData)
    ? sanityPageData
    : { pageTheme: defaultTheme };

  let { pageTheme } = pageData;
  pageTheme = checkValue(pageTheme) ? pageTheme : defaultTheme;
  const arrPageTheme = pageTheme.split('-');

  const themeType = arrPageTheme?.[0] === 'Meso' ? ThemeType.Meso : ThemeType.Brand;
  const themeColorMode = arrPageTheme?.[1] === 'Light' ? ThemeColorMode.Light : ThemeColorMode.Dark;

  const v3NavProps: V3NavProps = {
    id: 'v3-navigation-id',
    data: subHeaderProps,
    moduleName: 'v3-navigation',
    themeType,
    themeColorMode,
    globalNavigationData: pageData?.globalNavigationData
  };

  const isV3PageModule = checkValue(sanityPageData) || pageModuleVersion === 'V3';
  const extraProps = isV3PageModule ? { themeColorMode, themeType } : {};

  // Render Top Ad Unit
  const topAdUnit = () => {
    if (checkValue(pageData) && checkValue(pageData?.adUnitsNotMiddle, true)) {
      return pageData?.adUnitsNotMiddle?.filter(adUnit => adUnit?.layout === 'Leaderboard')?.map((adUnit, index) => {
        const componentProps: ComponentLayoutType<any> = {
          moduleName: 'v3adUnit',
          data: {
            ...adUnit
          },
        };
        return <V3AdUnits key={`adUnit-${index}`} {...componentProps} />;
      });
    } else {
      return null;
    }
  }; 

  info('Rendering Football pageLayout Content `football-hub`');
  return (
    <Layout className={`${className} ${brand}`}>
      <Theme brand={brand} {...extraProps}>
        {isV3PageModule ? (
          <>
            {topAdUnit()}
            <V3Navigation {...v3NavProps} />
          </>
        ) : (
          <GlobalHeader
            isSubHeader={isSubHeader}
            subHeaderProps={subHeaderProps}
            isPartnerHeader={isPartnerHeader}
            progressBarType={progressBarType}
          />
        )}
        {children}
        <GlobalFooterComponent isSocialLinks={isSocialLinks} socialModule={socialModule} themeType={themeType} />
      </Theme>
    </Layout>
  );
};

export { MasterPageProps, MasterPage };
